import React from 'react';
import clsx from 'clsx';
import {
  Grid,
  IconButton,
  Typography,
  Button,
  Dialog,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';
import useStyles from './styles';

function ConfirmationModal(props) {
  const {
    open,
    header,
    content,
    onCancelText,
    onConfirmText,
    onConfirm,
    onCancel,
    hideCancel,
    confirmDisabled,
    type = 'save',
  } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  const getDefaultHeader = () => {
    if (type === 'delete') {
      return t('component.label.delete', 'Delete');
    }
    if (type === 'save') {
      return t('component.label.save_changes', 'Save changes?');
    }
    if (type === 'leave') {
      return t('component.label.leave_confirmation', 'Are you sure you want to leave?');
    }

    return '';
  };

  const getDefaultConfirmText = () => {
    if (type === 'delete') {
      return t('component.label.delete', 'Delete');
    }
    if (type === 'save') {
      return t('component.label.save', 'Save');
    }
    if (type === 'leave') {
      return t('component.label.leave', 'Leave');
    }

    return '';
  };

  const getDefaultCancelText = () => {
    if (type === 'leave') {
      return t('component.label.stay', 'Stay');
    }

    return t('component.label.cancel', 'Cancel');
  };

  const getDefaultContent = () => {
    if (type === 'delete') {
      return (
        <>
          <Typography>{t('component.label.delete_confirmation_message', 'Are you sure you want to do this?')}</Typography>
          <Typography variant="caption">{t('component.label.cannot_undo', 'Note: You cannot undo this')}</Typography>
        </>
      );
    }
    if (type === 'leave') {
      return (
        <Typography color="textSecondary">
          {t('component.message.unsaved_changes_leave', 'You have unsaved changes. If you leave the page, these changes will be lost.')}
        </Typography>
      );
    }

    return '';
  };

  return (
    <Dialog open={open} onClose={onCancel}>
      <div className={classes.root}>
        <Grid
          container
          className={classes.heading}
          justifycontent="space-between"
          alignItems="center"
        >
          <Typography variant="h4">{header || getDefaultHeader()}</Typography>
          <IconButton size="small" onClick={onCancel} className={classes.closeButton}>
            <CloseIcon />
          </IconButton>
        </Grid>
        {content || getDefaultContent()}
        <div className={classes.controls}>
          {
            !hideCancel && (
              <Button variant="outlined" onClick={onCancel}>
                {onCancelText || getDefaultCancelText()}
              </Button>
            )
          }
          <Button
            variant="contained"
            color="secondary"
            disabled={confirmDisabled}
            className={clsx(
              ['delete', 'leave'].includes(type) && classes.errorButton,
            )}
            onClick={onConfirm}
          >
            {onConfirmText || getDefaultConfirmText()}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

ConfirmationModal.propTypes = {
  type: PropTypes.string,
  header: PropTypes.string,
  open: PropTypes.bool,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  content: PropTypes.node,
  onConfirmText: PropTypes.string,
  onCancelText: PropTypes.string,
  hideCancel: PropTypes.bool,
  confirmDisabled: PropTypes.bool,
};

ConfirmationModal.defaultProps = {
  type: '',
  onConfirmText: '',
  onCancelText: '',
  hideCancel: false,
  confirmDisabled: false,
  header: '',
  open: false,
  onConfirm: () => {},
  onCancel: () => {},
  content: null,
};

export default ConfirmationModal;
